import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { CompartmentListFacade } from './compartment-list.facade';

@Injectable({
  providedIn: 'root',
})
export class CompartmentListGuard {
  constructor(private compartmentListFacade: CompartmentListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.compartmentListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentListFacade);
  }
}
